import { Box, Divider, Stack, Text } from "@chakra-ui/react";
import Layout from "components/Layout";
import { useMemo, useRef } from "react";
import useUser from "components/hooks/useUser";
import RequestTable, { RequestTableRef } from "components/RequestTable";
import RequestForm from "components/RequestForm";

export default function Requests() {
  const { id: userId } = useUser();
  const tableRef = useRef<RequestTableRef>(null);

  const filter = useMemo(() => ({ requested_by: { _eq: userId } }), [userId]);

  return (
    <Layout>
      <Box>
        <RequestForm
          onSave={(req) => {
            tableRef.current?.findAndUpdate(req.id, req);
          }}
        />
        <Divider my={2} />
      </Box>

      <Stack height={"100%"} spacing={4}>
        <Text fontSize="xl">My Requests</Text>
        <RequestTable ref={tableRef} filter={filter} showDelete showReview />
      </Stack>
    </Layout>
  );
}
